import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getBasket, patchBasket, deleteBasket, createBasket } from '../services/ShoppingBasketPublicService';

export const useShoppingBasketPublicGetBasket = createDCHook('getBasket', collapseDataFromCall(getBasket), {
  injectables: ['label', 'businessUnit'],
  flattenData: true,
});

export const useShoppingBasketPublicPatchBasket = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(patchBasket, 'requestBody', 'data'),
      'data',
      'status',
      'flowInfo',
      'offers',
      'usages',
      'orderInfo',
      'attributes',
      'selectedDiscountCode',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['status', 'flowInfo', 'offers', 'usages', 'orderInfo', 'attributes', 'selectedDiscountCode'],
      },
    ],
  },
);

export const useShoppingBasketPublicDeleteBasket = createMutationHook(deleteBasket, {
  injectables: ['label', 'businessUnit'],
  flattenData: false,
});

export const useShoppingBasketPublicCreateBasket = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createBasket, 'requestBody', 'data'),
      'data',
      'status',
      'flowInfo',
      'offers',
      'usages',
      'orderInfo',
      'attributes',
      'selectedDiscountCode',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['status', 'flowInfo', 'offers', 'usages', 'orderInfo', 'attributes', 'selectedDiscountCode'],
      },
    ],
  },
);
